import { collection, getDocs } from "firebase/firestore"
import { firestore } from "../utilities/firebaseConfig"

export const findAll = async () => {
	const store = await getDocs(collection(firestore, "shops"))
	let res: Array<any> = []
	store.forEach(each => {
		// const { title, body, description, image } = post.data();
		res.push(each.data())
	})
	return res
}